import { render, staticRenderFns } from "./ProfileEmployee.vue?vue&type=template&id=351f22db"
import script from "./ProfileEmployee.vue?vue&type=script&lang=js"
export * from "./ProfileEmployee.vue?vue&type=script&lang=js"
import style0 from "./ProfileEmployee.vue?vue&type=style&index=0&id=351f22db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports